export const ACTIVITY_TYPE = {
  LESSON: 'lesson',
};